import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const ShieldIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 16 16"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="none"
    fill="currentColor"
  >
    <path
      d="M14.25.125H1.75c-.33152 0-.64946.131696-.883884.366116C.631696.725537.5 1.04348.5 1.375v4.59141c0 7.00079 5.92344 9.32339 7.10938 9.71799.25329.0861.52795.0861.78124 0C9.57812 15.2898 15.5 12.9672 15.5 5.96641V1.375c0-.33152-.1317-.649463-.3661-.883884C14.8995.256696 14.5815.125 14.25.125Zm0 5.84297c0 6.12653-5.18359 8.17343-6.25 8.52973-1.05703-.3524-6.25-2.3977-6.25-8.52973V1.375h12.5v4.59297Z"
      fill="currentColor"
      stroke="none"
    />
  </SvgIcon>
);

export default ShieldIcon;
